





































































import ItemListPanel from "@/general/components/molecules/ItemListPanel.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowLeft from "@/common/components/icons/IconArrowLeft.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";

import { mapState } from "vuex";
import { Prop, Vue, Component } from "vue-property-decorator";
import globals from "@/general/store/modules/globals";
import { SwiperOptions, Swiper as SwipeClass, Navigation } from "swiper";

SwipeClass.use([Navigation]);

@Component({
  components: {
    ItemListPanel,
    IconBase,
    IconArrowLeft,
    IconArrowRight,
    Swiper,
    SwiperSlide
  }
})
export default class ItemCarousel extends Vue {
  @Prop({ type: Array, required: false }) itemList!: any;
  @Prop({ type: String, required: false, default: "default" })
  carouselName!: string;

  swiperOption: SwiperOptions = {
    slidesPerView: 4,
    spaceBetween: 16,
    slidesPerGroup: 4,
    // loop: true, // NOTICE: If set to true, click event will not be cloned.
    loopFillGroupWithBlank: true,
    navigation: {
      nextEl: `.p-item-carousel--${this.carouselName} .p-item-carousel__button--next`,
      prevEl: `.p-item-carousel--${this.carouselName} .p-item-carousel__button--prev`
    },
    watchOverflow: true
  };

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }
}
